import { ApplicationConfig, provideAppInitializer } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { includeBearerTokenInterceptor } from 'keycloak-angular';
import { CtBatchApiService } from '@ps-gui/claims-terminal-shared';
import {
  AuthenticationService,
  BackendUrlConfig,
  initializeKeyStates,
  KeycloakAuthenticationService,
  provideConfigFromUri,
} from '@ps-gui/shared-core';
import { provideRouter, Routes } from '@angular/router';
import { ExternalPreviewComponent } from './preview/external-preview.component';
import { environment } from '../environments/environment';

const appRoutes: Routes = [
  {
    path: ':auditId',
    component: ExternalPreviewComponent,
  },
];

export const appConfig: ApplicationConfig = {
  providers: [
    {
      provide: AuthenticationService,
      useClass: KeycloakAuthenticationService,
    },
    MessageService,
    ConfirmationService,
    CtBatchApiService,
    provideHttpClient(withFetch(), withInterceptors([includeBearerTokenInterceptor])),
    provideAppInitializer(() => initializeKeyStates()),
    provideConfigFromUri<BackendUrlConfig>('./assets/config/config.json'),
    environment.provideKeycloak(),
    provideRouter(appRoutes),
  ],
};
